import { render, staticRenderFns } from "./FontSizeChoice.vue?vue&type=template&id=0db4de68&scoped=true&"
import script from "./FontSizeChoice.vue?vue&type=script&lang=js&"
export * from "./FontSizeChoice.vue?vue&type=script&lang=js&"
import style0 from "./FontSizeChoice.vue?vue&type=style&index=0&id=0db4de68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4de68",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default})
